import DateTime from '@dealroadshow/uikit-date-time';
import { IValidationError } from './interfaces/ValidationError';

export interface IParams {
  dateToTimestamp: number | null,
  dateFromTimestamp: number | null,
  fieldName: string,
  fieldCaption?: string,
  dateFromFieldCaption: string,
}

export const validateDateTo = (params: IParams): IValidationError | null => {
  const {
    dateToTimestamp,
    dateFromTimestamp,
    fieldName,
    fieldCaption,
    dateFromFieldCaption,
  } = params;

  if (!dateToTimestamp || !dateFromTimestamp) return null;

  const dateTo = new DateTime(dateToTimestamp);
  const dateFrom = new DateTime(dateFromTimestamp);

  if (dateTo.isAfter(dateFrom)) {
    return null;
  }

  return {
    [fieldName]: `${ fieldCaption || 'Field' } can't be the same or earlier than ${ dateFromFieldCaption }`,
  };
};
